import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        top: 20,
        right: 30,
        maxHeight: 280,
        overflowY: "auto",
        "@media (min-width: 1600px)": {
            gap: theme.spacing(2),
        },
    },
    dataContainer: {
        marginRight: 5,
    },
    failureTypeContainer: {
        display: "flex",
        gap: theme.spacing(1),
    },
    valueContainer: {
        marginLeft: 28,
    },
    value: {
        fontWeight: 700,
    },
}));
